var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isLoading && _vm.missingFiles.length)?_c('div',{staticClass:"ws-group-missing-files"},[_c('b-tooltip',{attrs:{"label":_vm.tooltipLabel,"position":"is-bottom","type":'is-danger'}},[_c('ws-dot-status',{attrs:{"type":"danger"}})],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }